import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ReportTagsQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  filters?: Types.InputMaybe<Types.TagsFilters>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type ReportTagsQuery = { tags?: { totalCount?: number | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string, type: Types.TagTypeEnum, availableOn: Array<Types.TagAvailableOnEnum>, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } } | { id: string, name: string, type: Types.TagTypeEnum, availableOn: Array<Types.TagAvailableOnEnum>, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } } | { id: string, name: string, type: Types.TagTypeEnum, availableOn: Array<Types.TagAvailableOnEnum>, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } } | { id: string, name: string, type: Types.TagTypeEnum, availableOn: Array<Types.TagAvailableOnEnum>, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } } | { id: string, name: string, type: Types.TagTypeEnum, availableOn: Array<Types.TagAvailableOnEnum>, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } } | { id: string, name: string, type: Types.TagTypeEnum, availableOn: Array<Types.TagAvailableOnEnum>, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } } }> | null } | null };

export type ReportTagUnion_DateTagType_Fragment = { id: string, name: string, type: Types.TagTypeEnum, availableOn: Array<Types.TagAvailableOnEnum>, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };

export type ReportTagUnion_MultiSelectTagType_Fragment = { id: string, name: string, type: Types.TagTypeEnum, availableOn: Array<Types.TagAvailableOnEnum>, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };

export type ReportTagUnion_NumberTagType_Fragment = { id: string, name: string, type: Types.TagTypeEnum, availableOn: Array<Types.TagAvailableOnEnum>, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };

export type ReportTagUnion_SingleSelectTagType_Fragment = { id: string, name: string, type: Types.TagTypeEnum, availableOn: Array<Types.TagAvailableOnEnum>, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };

export type ReportTagUnion_TextTagType_Fragment = { id: string, name: string, type: Types.TagTypeEnum, availableOn: Array<Types.TagAvailableOnEnum>, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };

export type ReportTagUnion_UserTagType_Fragment = { id: string, name: string, type: Types.TagTypeEnum, availableOn: Array<Types.TagAvailableOnEnum>, settings: { iconSettings: { type: Types.IconTypeEnum, value: string } } };

export type ReportTagUnionFragment = ReportTagUnion_DateTagType_Fragment | ReportTagUnion_MultiSelectTagType_Fragment | ReportTagUnion_NumberTagType_Fragment | ReportTagUnion_SingleSelectTagType_Fragment | ReportTagUnion_TextTagType_Fragment | ReportTagUnion_UserTagType_Fragment;


export type ReportTagUnionFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ReportTagUnionFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportTagUnion on TagUnion {
  ... on SingleSelectTagType {
    id
    name
    type
    availableOn
    settings {
      iconSettings {
        type
        value
      }
    }
  }
  ... on SingleSelectTagType {
    id
    name
    type
    availableOn
    settings {
      iconSettings {
        type
        value
      }
    }
  }
  ... on MultiSelectTagType {
    id
    name
    type
    availableOn
    settings {
      iconSettings {
        type
        value
      }
    }
  }
  ... on NumberTagType {
    id
    name
    type
    availableOn
    settings {
      iconSettings {
        type
        value
      }
    }
  }
  ... on UserTagType {
    id
    name
    type
    availableOn
    settings {
      iconSettings {
        type
        value
      }
    }
  }
  ... on DateTagType {
    id
    name
    type
    availableOn
    settings {
      iconSettings {
        type
        value
      }
    }
  }
  ... on TextTagType {
    id
    name
    type
    availableOn
    settings {
      iconSettings {
        type
        value
      }
    }
  }
}
    `;
export const ReportTagsDocument = /*#__PURE__*/ gql`
    query reportTags($sort: [SortType!], $filters: TagsFilters, $after: String, $first: Float) {
  tags(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...ReportTagUnion
      }
    }
  }
}
    ${ReportTagUnionFragmentDoc}`;

export function useReportTagsQuery(options?: Omit<Urql.UseQueryArgs<ReportTagsQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportTagsQuery, ReportTagsQueryVariables>({ query: ReportTagsDocument, ...options });
};